import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home' // 首页
// import cadil from '@/views/cadil' // 首页




Vue.use(Router)

const originalPush = Router.prototype.push
// 修改 原型对象中的push方法
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const routes= [
    // 登录
    { path: '/', name: 'Home', component: Home },
    // { path: '/', name: 'cadil', component: cadil },

    {
        path: '/detail', name: 'detail', component: () => import('../views/Detail/detail.vue'), //分类详情页
    },
    {
        path: '/detailList', name: 'detailList', component: () => import('../views/Detail/detailList.vue'), //分类详情列表页
    },
    {
        path: '/readTuiJian', name: 'readTuiJian', component: () => import('../views/Detail/readTuiJian.vue'), //阅读推荐详情页
    },
    {
        path: '/moreDetail', name: 'moreDetail', component: () => import('../views/Detail/moreDetail.vue'), //阅读推荐列表页
    },
    {
        path: '/databasedetail', name: 'databasedetail', component: () => import('../views/Detail/databasedetail.vue'), //数据库详情页
    },
    {
        path: '/searchDetail', name: 'searchDetail', component: () => import('../views/Detail/searchDetail.vue'), //站内搜索详情页
    },
    {
        path: '/h5jump', name: 'h5jump', component: () => import('../views/h5jump.vue'), //站内搜索详情页
    },


    // {
    //     path: '/cadil', name: 'cadil', component: () => import('../views/cadil.vue'), //cadil
    // },

    
    
    
    
]
const router = new Router({
    // mode: 'history',
    routes,

    
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js